import { observer } from 'mobx-react';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';
import { InsuranceDetailsGrid } from './insuranceDetailsGrid';

export type InsuranceDetailsItemProps = {
  open: boolean;
  onClose: () => void;
  loanId?: string;
  document?: DocumentType;
};

export const InsuranceDetailsItem = observer(
  ({
    open,
    onClose,
    loanId,
    document,
  }: InsuranceDetailsItemProps) => {
    const dialogContent = open ? (
      <InsuranceDetailsGrid loanId={loanId} embedded />
    ) : null;

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Insurance Details"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Insurance Details"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={dialogContent}
            removeContentBox
          />
        )}
      </>
    );
  }
);

export default InsuranceDetailsItem;
